import { FC, MouseEventHandler, useCallback } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { useFlag } from "@unleash/proxy-client-react";
import { BillingCost } from "@/services/cloudchipr.api";
import { isResourceKubernetes } from "@/store/resources-grid/utils/helpers/isResourceKubernetes";
import { setK8SLiveUsageResourceDetailsDrawerResourceDataThunk } from "@/store/kubernetes-live-usage-mgmt/thunks/resources/setK8SLiveUsageResourceDetailsDrawerResourceDataThunk";
import { setLiveUsageResourceDetailsDrawerResourceDataThunk } from "@/store/live-usage-mgmt/thunks/resources/setLiveUsageResourceDetailsDrawerResourceDataThunk";
import { AllTypeResourceItem } from "@/store/resources-grid/utils/types/resources";
import { useAppDispatch } from "@/store/hooks";
import { BillingCostCell } from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/billing-cost/BillingCostCell";

export const BillingCostCellRenderer: FC<ICellRendererParams> = ({ data }) => {
  const dispatch = useAppDispatch();

  const enableAiKubernetesRecommendations = useFlag(
    "EnableAiKubernetesRecommendations",
  );

  const resource: AllTypeResourceItem | undefined = data?.resource;
  const billingCost: BillingCost | undefined = data?.resource?.billing_cost;

  const state =
    resource && "resource_state" in resource
      ? resource.resource_state
      : undefined;
  const createdAt =
    resource && "created_at" in resource ? resource.created_at : undefined;

  const clickHandler: MouseEventHandler = useCallback(
    (e) => {
      if (!resource) {
        return;
      }

      e.stopPropagation();

      if (isResourceKubernetes(resource)) {
        dispatch(
          setK8SLiveUsageResourceDetailsDrawerResourceDataThunk({
            resource,
            enableAiKubernetesRecommendations,
          }),
        );
      } else {
        dispatch(setLiveUsageResourceDetailsDrawerResourceDataThunk(resource));
      }
    },
    [dispatch, resource, enableAiKubernetesRecommendations],
  );

  return (
    <BillingCostCell
      state={state}
      createdAt={createdAt}
      onClick={clickHandler}
      billingCost={billingCost}
    />
  );
};
